export default "/images/menu-yellow.svg?ff45df2b21fa3dcf83a05be02b6b110d";